import React, { useEffect, useState } from 'react'
import { useRest } from '../../contexts/rest/use'
import { useConfig } from '../../contexts/config/use'
import { TicketCancelled } from './ticket_cancelled';
import { TicketCalled } from './ticket_called'
import { TicketWaiting } from './ticket_waiting'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Header } from '../header'
import { Footer } from '../footer'
import { CancelTicketInfo } from './cancel_ticket_info';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from "react-router-dom"
import { isFalsyOrEmpty } from '../helpers/object';
import { GetParametersFromHash } from '../helpers/search';
import { Queuedata } from '../../services/dto/queuedata.dto';

export const TicketPage = () => {
  const { state: { ticket }, actions: { handleCancelTicket, qrToDirectTicket } } = useRest();
  const { state: { config }, actions: {GetOfficeIDFromUrlID, GetQueueIDfromUrlID, LoadAll }} = useConfig();
  const [searchparams, setSearchParams] = useState();
  const [dynamicinfotext, setDynamicInfoText] = useState();
  const { actions: {t, dt}} = useTranslation();
  const [modal, setModal] = useState();
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles(theme);
  
  const cancelTicketModal = () => {
    if (!modal)
      setModal(true);
  }

  const cancelTicketCallback = () => {
    setModal(false);
    handleCancelTicket();
  }

  const closeModalCallback = () => {
    setModal(false);
  }

  useEffect(() => {
    var tickettext = JSON.parse(localStorage.getItem("tickettext"));
    sessionStorage.removeItem("formdata");
    if ( tickettext )
      setDynamicInfoText(tickettext)
  },[])

  useEffect(() => {
      if (config) 
      {

        var oldbaseurl = localStorage.getItem("baseurl");
        if (window.location.pathname !== oldbaseurl)
        {
          localStorage.removeItem("ticket");
          localStorage.removeItem("tickettext");
          localStorage.removeItem("selectedoffice");
          localStorage.removeItem("selectedqueuename");
          sessionStorage.removeItem("resources");
          sessionStorage.removeItem("queuename");
          sessionStorage.removeItem("formdata");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("tokenconfig");
          localStorage.setItem("baseurl", window.location.pathname);
          LoadAll();
          window.location.reload();
          return;
        }

        if (isFalsyOrEmpty(ticket) || ticket.cancelled)
        {
          const searchParams = GetParametersFromHash();
          if (searchParams)
          {
            searchParams.officeID = GetOfficeIDFromUrlID(searchParams.officeID);
            searchParams.queueID = GetQueueIDfromUrlID(searchParams.officeID, searchParams.queueID);
            setSearchParams(searchParams);
          }
          else
          {
            let officeID = localStorage.getItem("selectedoffice");
            let queueID = sessionStorage.getItem("selectedqueue");
            let segmentID = sessionStorage.getItem("segementID");
            let serviceID = sessionStorage.getItem("serviceID");
  
            if (config && config.uselandingpage && !officeID && (!queueID || (!segmentID && !serviceID)))
              history.push("/");
            else
              history.push("queues");
          }
        }
      }
  }, [config])

  useEffect(() => {
    if(searchparams)
    {
      var hash = window.location.hash.split("?")
      window.history.replaceState({}, '', window.location.origin + window.location.pathname + hash[0])
      var queuedata = new Queuedata(searchparams['queueID'], searchparams['segmentID'], searchparams['serviceID']);
      if (searchparams.officeID && (queuedata.queueID || (queuedata.segmentID && queuedata.serviceID)))
        qrToDirectTicket(searchparams.officeID, queuedata, t('queuepage.customertext'));
      else
        history.push("404")
    }
  },[searchparams])

  const ActualTicket = () => {
    var savedticket = JSON.parse(localStorage.getItem("ticket"));
    let officeID = localStorage.getItem("selectedoffice");
    if (!isFalsyOrEmpty(savedticket))
    {
      if (savedticket.cancelled)
        return <TicketCancelled ticket={savedticket} 
                cancelTicketCallback={handleCancelTicket} 
                timeouttext={t('ticketpage.ended')} 
                throwtickettext={t('ticketpage.finish')} 
                />   
      else if (savedticket.meetUpLocation)
        return <TicketCalled ticket={savedticket} 
                successtext={t('ticketpage.yourturn')} 
                meetuptext={t('ticketpage.goto')} 
                infotext={t('ticketpage.infotext')}
                dynamicinfotext={dynamicinfotext ? dynamicinfotext.map(x => { return {label: dt(officeID, x.label), value: x.value}}) : ""}
                />
      else
        return (
          <>
          { modal ? <CancelTicketInfo cancelticketcallback={cancelTicketCallback} closemodalcallback={closeModalCallback} /> : <span/> }
          <TicketWaiting 
            ticket={savedticket} 
            cancelTicketCallback={cancelTicketModal} 
            peopleaheadtext={t('ticketpage.peopleahead')} 
            ticketnumbertext={t('ticketpage.ticketnumber')} 
            leavequeuetext={t('ticketpage.leavequeue')} 
            infotext={t('ticketpage.infotext')}
            dynamicinfotext={dynamicinfotext ? dynamicinfotext.map(x => { return {label: dt(officeID, x.label), value: x.value}}) : ""}
            />
          </>
        )
    }
    else
    return (
      <div className={classes.spinnerwrapper}>
        <CircularProgress className={[classes.spinner, "Spinner"].join(' ')}/>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <Header/>
        { ActualTicket() }
      <Footer/>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: '1 0 auto'
  },
  spinner: theme => ({
    color: theme.palette.primary.main,
    height: '80%',
    width: '80%'
  }),
  spinnerwrapper: {
    height: '100%',
    width: '100%',
    flex: '1 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
})

